import { tryGetWebUrlWithProtocol } from "@entrilia/shared/utilities/urlHelper";
import { getVariables } from "../variables";

export const getEntriliaOrgClientCode = () => {
  const { HOST_ENV } = getVariables();
  return HOST_ENV.toLowerCase() === "development" ? "entrilia51" : "entrilia";
};

export const extractClientCodeFromUrl = (url: string): string | undefined => {
  const urlObj = tryGetWebUrlWithProtocol(url);
  if (!urlObj) {
    return undefined;
  }

  const parts = urlObj.hostname.toLowerCase().split(".");
  // "www" is never part of the client code. Drop it so a short domain name
  // (e.g. "abc" in www.abc.com) isn't discarded by the length filter below and
  // then replaced by "www" itself through the empty-candidate fallback.
  if (parts.length > 1 && parts[0] === "www") {
    parts.shift();
  }
  const partsWithoutLast = parts.slice(0, parts.length - 1);
  const candidateParts = partsWithoutLast.filter((part) => part.length > 3);
  const secondLevelDomain =
    (candidateParts.length === 0 ? partsWithoutLast[0] : candidateParts[candidateParts.length - 1]) ?? "";
  const sanitizedDomain = secondLevelDomain.replace(/[^a-z0-9]/g, "");
  return sanitizedDomain || undefined;
};
